import type { AlgoliaFacets } from '@jane/search/types';
import type { Store } from '@jane/shared/types';

import type { MenuCategory } from '../../../types';
import { getCustomRowRootType } from './getCustomRowRootType';

interface VisibleTabsProps {
  allSpecialsHidden?: boolean;
  facets?: AlgoliaFacets;
  hasBrandSpecials: boolean;
  hasSpecials: boolean;
  store?: Store;
}

export const visibleTabs = ({
  facets,
  hasBrandSpecials,
  hasSpecials,
  store,
  allSpecialsHidden,
}: VisibleTabsProps): MenuCategory[] => {
  const rootTypes = facets?.root_types ?? {};

  const {
    menu_tabs: menuTabs = [],
    custom_rows: customRows,
    id: storeId,
    specials_row_configs: specialsConfig,
  } = store ?? {};

  return menuTabs.reduce<MenuCategory[]>((categories, tab) => {
    if (!facets) {
      return [];
    }

    const showSpecials =
      hasSpecials && (specialsConfig?.enabled || customRows?.includes('sale'));
    const authEnabled =
      store?.kiosk_allow_auth && store?.kiosk_anonymous_checkout !== 'required';

    if (tab === 'featured') {
      const hasMagicRow = customRows?.includes('magic_row');
      const hasThematicRows = customRows?.includes('custom');
      const hasBrandSpecialsRow = customRows?.includes('brand_specials');

      const hasRows =
        hasBrandSpecialsRow || hasThematicRows || hasMagicRow || showSpecials;

      const hasProducts =
        (customRows || []).filter(
          (row) =>
            (rootTypes[getCustomRowRootType(row, Number(storeId))] ?? -1) > 0
        ).length > 0;

      return hasRows || hasProducts ? [...categories, tab] : categories;
    }

    if (tab === 'specials' && showSpecials && !allSpecialsHidden) {
      return showSpecials ? [...categories, tab] : categories;
    }

    if (tab === 'brand_specials' && hasBrandSpecials && authEnabled) {
      return [...categories, 'jane-gold'];
    }

    if (tab === 'all-products') {
      return [...categories, 'all'];
    }

    if (rootTypes[tab]) {
      return [...categories, tab as MenuCategory];
    }

    return categories;
  }, []);
};
